import { createClient } from 'next-sanity'

import { apiVersion, dataset, projectId } from '../env'

const stegaConfig = {
  enabled: false, // Will be enabled by sanityFetch in draft mode
  studioUrl: '/studio',
  filter: (props) => {
    const { value } = props
    if (typeof value === 'string' && value.length < 50) return false
    return props.filterDefault(props)
  },
} satisfies Parameters<typeof createClient>[0]['stega']

/**
 * Default client — `useCdn: true`.
 *
 * Use for reads OUTSIDE `'use cache'` boundaries: draft mode, build-time
 * `generateStaticParams`, one-off dashboards, etc. CDN bandwidth is
 * unlimited across all Sanity plans.
 */
export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: true,
  stega: stegaConfig,
})

/**
 * "Live" client — `useCdn: false`.
 *
 * Use for reads INSIDE `'use cache'` boundaries. The ~60s Sanity CDN
 * propagation window combined with Next tag invalidation causes a race
 * where a webhook fires, Next regenerates, and Sanity CDN still serves
 * pre-invalidation data — which Next then caches for the full
 * `cacheLife` duration.
 *
 * Bypassing the CDN on cache-misses ensures webhook invalidation always
 * produces fresh data. Call volume stays low because `'use cache'`
 * already soaks up repeat reads: only cache fills and invalidations
 * reach Sanity.
 */
export const liveClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false,
  stega: stegaConfig,
})
